import React, { useState } from "react";
import TitleFormat from "../../../components/TitleFormat";
import "./styles/Business.scss";
import MapNaver from "../../../components/MapNaver";
import MapNaverJeju from "../../../components/MapNaverJeju";
import { useTranslation } from "react-i18next";
import { Seo } from "../../../components/Seo";
//https://elvanov.com/2195
type BusinessItem = {
  name: string;
  list: string[];
};
const Business = () => {
  const { t } = useTranslation();
  const title = `ARCHITECO GROUP`;
  const [mapIndex, setMapIndex] = useState(0);
  const handleMap = (e: any) => {
    setMapIndex(Number(e.currentTarget.id));
  };

  const useBusinessItems = (key: string, imgPrefix: string) => {
    const items = t(key, { returnObjects: true }) as BusinessItem[];
    return items.map((item, idx) => ({
      path: `/imgs/${imgPrefix}${idx + 1}.png`,
      ...item,
    }));
  };

  const business_dt = useBusinessItems("aboutUs.business.dt.items", "business_area_0");
  const business_rnd = useBusinessItems("aboutUs.business.rnd.items", "business_rnd_0");

  const business_design = useBusinessItems("aboutUs.business.design.items", "business_dt_design_0");
  const business_total = useBusinessItems("aboutUs.business.total.items", "business_dt_eco_0");

  const content = (
    content: {
      path: string;
      name: string;
      list: string[];
    }[],
  ) => {
    return content.map((content: { path: string; name: string; list: string[] }, index: number) => {
      return (
        <div className="card" key={`${content.name}_${index}`}>
          <div className="img_box">
            <img src={`${content.path}`} alt="" />
          </div>
          <div className="name">{content.name}</div>
          <ul>
            {content.list.map((text: string, index: number) => {
              return <li key={`${text}_${index}`}>{text}</li>;
            })}
          </ul>
        </div>
      );
    });
  };

  const overviewList = t("aboutUs.business.overview.list", { returnObjects: true }) as string[][];
  const netZeroTitle = t("aboutUs.business.netZero.title", { returnObjects: true }) as {
    text: string;
    highlight?: "yellow" | "green";
  }[];
  const netZeroContent = t("aboutUs.business.netZero.content", { returnObjects: true }) as { icon: string; type: number; title: string; list: string[] }[];
  const netZeroCard = t("aboutUs.business.netZero.card", { returnObjects: true }) as { cardPath: string; title: string; list: string[]; speech_bubble: string }[];

  return (
    <>
      <Seo title={`${t("aboutUs.business.seo.title")}`} description={`${t("aboutUs.business.seo.des")}`} path="about/greeting" />
      <div id="business_wrap">
        <TitleFormat text={title} />
        <div className="overview_wrap">
          <div className="text_wrap">
            <div className="left_wrap">
              <div className="des">{t("aboutUs.business.overview.title.title")}</div>
              <div className="title">{t("aboutUs.business.overview.title.des")}</div>
            </div>
            <div className="right_wrap">
              <div className="list_wrap">
                {overviewList.map((list: string[], index) => {
                  return (
                    <ul key={`right_${index}`}>
                      {list.map((ment: string, index2) => {
                        return <li key={`${ment}_${index2}`}>{ment}</li>;
                      })}
                    </ul>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="img_box">
            <img src="/imgs/aboutus_business_building.png" alt="aboutus_business_building" />
          </div>
        </div>
        <div className="net_zero_wrp">
          <div className="top_wrap">
            <div className="img_box">
              <img src="/imgs/icon_time.png" alt="time icon" />
            </div>
            <div className="ment">
              {netZeroTitle.map((ment, index) => {
                return (
                  <span className={ment.highlight} key={`${ment.text}_${index}`}>
                    {ment.text}
                  </span>
                );
              })}
            </div>
          </div>
          <div className="title_wrap">
            <div className="title">{t("aboutUs.business.netZero.ment.title")}</div>
            <div className="des">{t("aboutUs.business.netZero.ment.des")}</div>
          </div>
          <div className="flow_wrap">
            <div className="upper">
              {netZeroContent.map((content, index) => {
                return (
                  <div className="card_wrap" key={`${content.title}_${index}`}>
                    <div className="img_box">
                      <img src={content.icon} alt={content.icon} />
                    </div>
                    {content.type === 1 ? (
                      <>
                        <div className="title_wrap">{content.title}</div>
                        <div className="list_wrap">
                          <ul>
                            {content.list.map((text, index2) => {
                              return <li key={`list_${index2}`}>{text}</li>;
                            })}
                          </ul>
                        </div>
                      </>
                    ) : (
                      <div className="box_wrap">{content.title}</div>
                    )}
                  </div>
                );
              })}
            </div>
            <div className="middle_wrap">
              <div className="img_box">
                <img src="/imgs/diagram_netzero_5.png" alt="diagram_netzero" />
              </div>
              <div className="bar"></div>
            </div>
            <div className="under">
              {netZeroCard.map((content, index) => {
                return (
                  <div className="card_wrap" key={`netzero_${content.title}_${index}`}>
                    {content.speech_bubble === "" ? null : <div className="speech_bubble_wrap">Why Only Architeco Group</div>}
                    <div className="card" key={`${content.title}_${index}`}>
                      <div className="content_wrap">
                        <div className="title">{content.title}</div>
                        <ul>
                          {content.list.map((text, index2) => {
                            return <li key={`${text}_${index2}`}>{text}</li>;
                          })}
                        </ul>
                      </div>
                      <img src={`${content.cardPath}`} alt="card" />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="business_list_wrap">
          <h2 className="title">Business Area</h2>
          <div className="content_wrap">
            <div className="left">
              <span>{t("aboutUs.business.dt.title")}</span>
            </div>
            <div className="right">{content(business_dt)}</div>
          </div>
          <div className="content_wrap">
            <div className="left">
              <span>{t("aboutUs.business.rnd.title")}</span>
            </div>
            <div className="right">{content(business_rnd)}</div>
          </div>
          <div className="content_wrap">
            <div className="left">
              <span>{t("aboutUs.business.design.title")}</span>
            </div>
            <div className="right">{content(business_design)}</div>
          </div>
          <div className="content_wrap">
            <div className="left">
              <span>{t("aboutUs.business.total.title")}</span>
            </div>
            <div className="right">{content(business_total)}</div>
          </div>
        </div>
        <div className="m_wrap">
          <div className="sub_title">{t("aboutUs.business.map.title")}</div>
          <div className="des">
            {t("aboutUs.business.map.address.road")} / {t("aboutUs.business.map.address.land")} <br /> {t("aboutUs.business.map.address.detail")}
          </div>
          <div className="tap_wrap">
            <ul>
              <li id="0" className={`${0 === mapIndex ? "active" : ""}`} onClick={handleMap}>
                {t("aboutUs.business.map.office.seoul")}
              </li>
              <li id="1" className={`${1 === mapIndex ? "active" : ""}`} onClick={handleMap}>
                {t("aboutUs.business.map.office.jeju")}
              </li>
            </ul>
          </div>
          {mapIndex === 0 ? (
            <>
              <div className="map_wrap">
                <MapNaver />
              </div>
              <div className="info_wrap">
                <div className="info parking_wrap">
                  <div className="left">
                    <div className="icon_text">P</div>
                    <div className="text">{t("aboutUs.business.map.transport.parking.title")}</div>
                  </div>
                  <div className="right">
                    <div className="parking_point_1">
                      <div className="fw_b">{t("aboutUs.business.map.transport.parking.location.name")}</div>
                      <div>
                        {t("aboutUs.business.map.transport.parking.location.addressLabel")} : {t("aboutUs.business.map.transport.parking.location.address")}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="info subway_wrap">
                  <div className="left">
                    <div className="icon_box">
                      <img src="/imgs/icon_subway.png" alt="subway_icon" />
                    </div>
                    <div className="text">{t("aboutUs.business.map.transport.subway.title")}</div>
                  </div>
                  <div className="right">
                    <div className="point_01">
                      <div>
                        <span className="ball">8</span>
                        <span className="fw_b fc_y">
                          {t("aboutUs.business.map.transport.subway.line")} {t("aboutUs.business.map.transport.subway.station")}
                        </span>
                      </div>
                      <div>
                        <span className="fw_b">{t("aboutUs.business.map.transport.subway.exit.exit3.number")}</span> {t("aboutUs.business.map.transport.subway.exit.exit3.description")}
                      </div>
                    </div>
                    <div className="point_02">
                      <span className="fw_b">{t("aboutUs.business.map.transport.subway.exit.exit4.number")}</span> {t("aboutUs.business.map.transport.subway.exit.exit4.description")}
                    </div>
                  </div>
                </div>
                <div className="info bus_wrap">
                  <div className="left">
                    <div className="icon_text">B</div>
                    <div className="text">{t("aboutUs.business.map.transport.bus.title")}</div>
                  </div>
                  <div className="right">
                    <div className="point">
                      <div className="station">
                        <div className="fw_b">{t("aboutUs.business.map.transport.bus.stations.case_1.name")}</div>
                        <div>{t("aboutUs.business.map.transport.bus.stations.case_1.direction")}</div>
                      </div>
                      <div className="bus_route">
                        <div>
                          <span className="fw_b fc_r">500-1,500-1A,1009,1112</span>
                        </div>
                        <div>
                          <span className="fw_b fc_g">30,31,32,100,119,331</span>
                        </div>
                        <div>
                          <span className="fw_b fc_b">302,303,320,333,343</span>
                        </div>
                      </div>
                    </div>
                    <div className="point">
                      <div className="station">
                        <div className="fw_b">{t("aboutUs.business.map.transport.bus.stations.case_2.name")}</div>
                        <div>{t("aboutUs.business.map.transport.bus.stations.case_2.direction")}</div>
                      </div>
                      <div className="bus_route">
                        <div>
                          <span className="fw_b fc_r">500-1,500-1A,1009,1112</span>
                        </div>
                        <div>
                          <span className="fw_b fc_g">30,31,32,100,119,331</span>
                        </div>
                        <div>
                          <span className="fw_b fc_b">302,303,320,333,343</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="map_wrap">
                <MapNaverJeju />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Business;
